module.exports = __webpack_public_path__ + "img/29.a46fd99a.jpg";